/** Visibility only; the documented API enforces custody and reader ACL. */
export function ArchiveNavigation({ allowed }: { allowed: boolean }) {
  return allowed ? <a className="btn btn-quiet btn-sm" href="/app/conversations/archive">Historical archive</a> : null;
}
